import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../../../../app.service';
import { QuestionHistoryInfo, QustionHistoryVM } from '../../../favourite-dialog/favourite-dialog-modal';
import { DigitalFormService } from '../../digital-form.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DigitalFormSectionQuestionsComponent } from '../digital-form-section-questions/digital-form-section-questions.component';

@Component({
  selector: 'app-normal-question-history',
  templateUrl: './normal-question-history.component.html',
  styleUrls: ['./normal-question-history.component.scss']
})
export class NormalQuestionHistoryComponent implements OnInit {
  QuestionHistoryresult:QustionHistoryVM;
  historyList :QuestionHistoryInfo[];
  constructor(
    private _dialogRef: MatDialogRef<NormalQuestionHistoryComponent>, 
    private _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _appService: AppService,
    private _router: Router, 
    private _formService:DigitalFormService
  ) { }

  ngOnInit() {
    this.QuestionHistoryresult=this._data.QuestionHistoryresult;
    this.historyList = this.QuestionHistoryresult.HistoryList;
    console.log(this.historyList);
  }
  onNoClick(){
    this._dialogRef.close(false);
  }

  GotoSelectedQuestion(selectedQ:QuestionHistoryInfo){
    // let baseUrl = window.location.href.replace(this._router.url, '');
    // window.open(baseUrl + '/digitalForm/Fill' selectedQ.FormId, selectedQ.UploadId,selectedQ.SectionId,selectedQ.QId, '_blank');
   // this._router.navigate(['/digitalForm/Fill', selectedQ.FormId, selectedQ.UploadId,selectedQ.SectionId,selectedQ.QId]);
  }

  LoadSelectedCatData(formId: number,sectionId: number, QuestionID: number, UploadId: number){
    const dialogRef = this._dialog.open( DigitalFormSectionQuestionsComponent, {
      width: '70%',
      height: '70%',
      disableClose: true,
      data: {
        FormId: formId,
        SectionId: sectionId,
        QuestionID: QuestionID,
        UploadId: UploadId
      }
    });
    dialogRef.afterClosed().subscribe(r => {
      //this.LoadFormUploadDetails();
    });
  }
}
